import { RauteMark } from "@/components/ui/RauteMark";

interface KickerProps {
  color: string;
  label: string;
}

/** Small Raute + uppercase label used above every Protokolle header title
 * ("Wiederkehrende Besprechungen", "Besprechungsreihe · Vertrieb", …). */
export function Kicker({ color, label }: KickerProps) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      <RauteMark color={color} size={8} />
      <span
        style={{
          fontFamily: "var(--font-display)",
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: ".12em",
          textTransform: "uppercase",
          color: "var(--ink-2)",
        }}
      >
        {label}
      </span>
    </span>
  );
}
